import { useState, useRef, useEffect } from "react";
import Lottie from "lottie-react";
import Link from "next/link";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import { setCinemaHamrahState } from "../../../../../redux/slices/videoDataSlice";
import { CinemaHamrahState, ConditionName, zIndex } from "../../../../../interfaces";
import fullrateAnimation from "../../../../../images/lottieAnimations/fullrate.json";
import hasPlanAnimation from "../../../../../images/lottieAnimations/hasPlan.json";
import hasNoPlanAnimation from "../../../../../images/lottieAnimations/hasNoPlan.json";
import { conditions } from "../../../../../helpers";
import { shallowEqual } from 'react-redux'

const CinemaHamrahPopover = () => {

    const [width, setWidth] = useState<number>(0);

    const dispatch = useAppDispatch();
    const { cinemaHamrahState } = useAppSelector(({ videoData: { cinemaHamrahState, isComplexPortrait } }) => ({ cinemaHamrahState, isComplexPortrait }), shallowEqual);

    const intervalRef = useRef<any>(null);

    const handleClickButton = (event:any) => {
        event.stopPropagation();
        dispatch(setCinemaHamrahState(undefined));
    }

    useEffect(() => {
        if (cinemaHamrahState !== CinemaHamrahState.hasNoPlan) intervalRef.current = setInterval(() => setWidth((prev) => prev + 0.2), 10)
        return () => clearInterval(intervalRef.current);
    }, [])

    useEffect(() => {
        if (width >= 100 && cinemaHamrahState !== CinemaHamrahState.hasNoPlan) dispatch(setCinemaHamrahState(undefined));
    }, [width])

    let popoverContent = <></>;

    switch (cinemaHamrahState) {
        case CinemaHamrahState.fullrate:
            popoverContent = (
                <div className="pl-flex pl-flex-col pl-justify-center pl-items-center pl-px-[35px] pl-pb-5">
                    <Lottie animationData={fullrateAnimation} loop={true} style={{ width: conditions(ConditionName.isComplexPortrait) ? 92 : 242, height: conditions(ConditionName.isComplexPortrait) ? 79 : 208 }} />
                    <p className={`${conditions(ConditionName.isComplexPortrait) ? "pl-mt-0.5 pl-mb-2 pl-text-[12px] pl-max-w-[291px]" : "pl-mt-[29px] pl-mb-8 pl-text-[18px] pl-max-w-[785px]"} pl-font-bold pl-text-gray-800 dark:pl-text-white pl-text-center`}>این محتوا رایگان است اما ترافیک اینترنت به صورت تمام بها محاسبه می‌شود.</p>
                    <button onClick={handleClickButton} className="pl-w-full pl-px-6 pl-py-2 pl-bg-main-light pl-text-[15px] pl-font-bold pl-rounded-[8px] pl-text-white">پخش ویدیو</button>
                    <div className={`pl-absolute pl-bottom-0 pl-left-0 pl-w-full pl-bg-z-gray-400 dark:pl-bg-gray-600 pl-rounded-[4px] ${conditions(ConditionName.isComplexPortrait) ? "pl-h-[5px]" : "pl-h-[10px]"}`}>
                        <div className={`pl-absolute pl-bottom-0 pl-left-0 pl-bg-z-yellow-light pl-rounded-[4px] ${conditions(ConditionName.isComplexPortrait) ? "pl-h-[5px]" : "pl-h-[10px]"}`} style={{ width: `${width}%` }}></div>
                    </div>
                </div>
            )
            break;
        case CinemaHamrahState.hasPlan:
            popoverContent = (
                <div className="pl-flex pl-flex-col pl-justify-center pl-items-center pl-px-[35px] pl-pb-5">
                    <Lottie animationData={hasPlanAnimation} loop={true} style={{ width: conditions(ConditionName.isComplexPortrait) ? 92 : 242, height: conditions(ConditionName.isComplexPortrait) ? 79 : 208 }} />
                    <p className={`${conditions(ConditionName.isComplexPortrait) ? "pl-mt-0.5 pl-mb-2 pl-text-[12px] pl-max-w-[291px]" : "pl-mt-[29px] pl-mb-8 pl-text-[18px] pl-max-w-[785px]"} pl-font-bold pl-text-gray-800 dark:pl-text-white pl-text-center`}>کاربر گرامی همراه اول، بسته سینماهمراه شما فعال می‌باشد و می‌توانید این فیلم سینمایی را با ترافیک رایگان تماشا کنید.</p>
                    <button onClick={handleClickButton} className="pl-w-full pl-px-6 pl-py-2 pl-bg-main-light pl-text-[15px] pl-font-bold pl-rounded-[8px] pl-text-white ">پخش ویدیو</button>
                    <div className={`pl-absolute pl-bottom-0 pl-left-0 pl-w-full pl-bg-z-gray-400 dark:pl-bg-gray-600 pl-rounded-[4px] ${conditions(ConditionName.isComplexPortrait) ? "pl-h-[5px]" : "pl-h-[10px]"}`}>
                        <div className={`pl-absolute pl-bottom-0 pl-left-0 pl-bg-z-yellow-light pl-rounded-[4px] ${conditions(ConditionName.isComplexPortrait) ? "pl-h-[5px]" : "pl-h-[10px]"}`} style={{ width: `${width}%` }}></div>
                    </div>
                </div>
            )
            break;   
        case CinemaHamrahState.hasNoPlan:
            popoverContent = (
                <div className="pl-flex pl-flex-col pl-justify-center pl-items-center pl-px-[35px]">
                    <Lottie animationData={hasNoPlanAnimation} loop={true} style={{ width: conditions(ConditionName.isComplexPortrait) ? 92 : 242, height: conditions(ConditionName.isComplexPortrait) ? 79 : 208}} />
                    <p className={`${conditions(ConditionName.isComplexPortrait) ? "pl-mt-0.5 pl-mb-2 pl-text-[14px] pl-max-w-[291px]" : "pl-mt-[29px] pl-mb-8 pl-text-[18px] pl-max-w-[785px]"} pl-font-bold pl-text-gray-800 dark:pl-text-white pl-text-center`}>کاربر گرامی برای تماشای فیلم سینمایی، نیاز به خرید بسته سینما همراه می‌باشد، شما می‌توانید از طریق لینک زیر نسبت به خرید بسته اقدام نمایید:</p>
                    <div className={`pl-flex pl-flex-col pl-gap-[14px] pl-items-center pl-text-[18px] pl-font-bold pl-text-main-light`}>
                        <Link href="https://shop.mci.ir/packages">https://shop.mci.ir/packages</Link>
                        <p style={{direction:"ltr"}}>*100*25#</p>
                    </div>
                </div>
            )
            break;  
    }

    return (
        <div className="pl-border pl-border-secondary-400 pl-absolute pl-w-full pl-h-full pl-flex pl-justify-center pl-items-center" style={{ zIndex: zIndex.voucher }}>
            <div className="pl-absolute pl-w-full pl-h-full pl-bg-transparent pl-backdrop-blur-[5px]" />
            <div className="pl-bg-white/[0.9] dark:pl-bg-dark-1/[0.9] pl-rounded-[8px]" style={{ boxShadow: conditions(ConditionName.isTouchScreenPortrait) ? "unset" : "0px 4px 4px 0px rgba(0, 0, 0, 0.25)", zIndex: zIndex.voucher }}>{popoverContent}</div>
        </div>
    )
}

export default CinemaHamrahPopover;